import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const projectRouter: RouteConfig = {
  path: '/projects',
  component: Layout,
  redirect: '/projects/project_list',
  name: '项目管理',
  meta: {
    title: '项目管理'
  },
  children: [
    {
      path: 'project_list',
      name: 'project_list',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/projectList.vue'),
      meta: {
        title: '项目列表'
      }
    },

    {
      path: 'detail/:id',
      name: 'projectsDetail',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/detail.vue'),
      meta: {
        title: '项目详情'
      }
    },
    {
      path: 'paymentsAndReceiptses',
      name: 'paymentsAndReceiptses',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/projectPaymentsAndReceiptsesList.vue'),
      meta: {
        title: '项目收拨款'
      }
    },
    {
      path: 'paymentsAndReceiptsesList/:id',
      name: 'paymentsAndReceiptsesList',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/projectPaymentsAndReceiptsesList.vue'),
      meta: {
        title: '项目收拨款'
      }
    },
    {
      path: 'ledger/:projectId',
      name: 'ledgerList',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/ledgerList.vue'),
      meta: {
        title: '项目台账'
      }
    },
    {
      path: 'ledgerList',
      name: 'ledgerList2',
      component: () => import(/* webpackChunkName: "project" */'@/views/projects/ledgerList.vue'),
      meta: {
        title: '项目台账'
      }
    },
  ]
}

export default projectRouter
